(function () {
  'use strict';

  var manager = window.repodExperienceManager;

  if (!manager) {
    manager = (function () {
      var sections = [];
      var modelElement = null;
      var heroElement = null;
      var homeAnchor = null;
      var activeSection = null;
      var heroRatio = 0;
      var heroSeen = false;
      var retryTimer = null;
      var retryRunning = false;

      var observer = new IntersectionObserver(onIntersection, {
        root: null,
        rootMargin: '10% 0px 10% 0px',
        threshold: [0, 0.01, 0.15, 0.35, 0.6]
      });

      function stateForElement(element) {
        return sections.find(function (state) {
          return state.element === element;
        });
      }

      function onIntersection(entries) {
        entries.forEach(function (entry) {
          if (entry.target === heroElement) {
            heroSeen = true;
            heroRatio = entry.isIntersecting ? entry.intersectionRatio : 0;
            return;
          }

          var state = stateForElement(entry.target);
          if (!state) return;
          state.seen = true;
          state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
        });

        updateMount();
      }

      function ensureModel() {
        if (modelElement && modelElement.isConnected && homeAnchor && homeAnchor.isConnected) return true;

        var runtime = window.repodHeroRuntime;
        modelElement = modelElement && modelElement.isConnected
          ? modelElement
          : runtime && runtime.modelElement
            ? runtime.modelElement
            : document.querySelector('.hero .hero__product');

        if (!modelElement) return false;

        heroElement = modelElement.closest('.hero');
        if (!homeAnchor || !homeAnchor.isConnected) {
          homeAnchor = document.createComment('repod-shared-model-home');
          modelElement.parentNode.insertBefore(homeAnchor, modelElement);
        }

        if (heroElement) observer.observe(heroElement);
        refreshReadiness();
        return true;
      }

      function reconnectHero(element) {
        if (!element) return null;

        var previousHero = heroElement;
        if (previousHero && previousHero !== element) observer.unobserve(previousHero);
        heroElement = element;
        observer.observe(heroElement);

        var runtime = window.repodHeroRuntime;
        modelElement = modelElement || (runtime && runtime.modelElement);
        if (!modelElement) return null;

        var placeholder = heroElement.querySelector('.hero__product');
        var homeParent = placeholder && placeholder.parentNode;
        if (!homeParent) return modelElement;

        if (homeAnchor && homeAnchor.isConnected && homeAnchor.parentNode !== homeParent) {
          homeAnchor.remove();
        }
        if (!homeAnchor || !homeAnchor.isConnected) {
          homeAnchor = document.createComment('repod-shared-model-home');
          homeParent.insertBefore(homeAnchor, placeholder);
        }

        var mountedInExperience = !!modelElement.closest('[data-repod-experience]');
        if (mountedInExperience) {
          if (placeholder !== modelElement) placeholder.remove();
        } else {
          if (placeholder !== modelElement) placeholder.replaceWith(modelElement);
          modelElement.classList.remove('repod-experience__shared-product', 'model-load-failed');
          modelElement.classList.add('model-is-ready');
          sections.forEach(function (state) {
            state.element.classList.remove('is-model-mounted');
          });
          activeSection = null;
          setPresentationQuality(false);
          setPresentationLighting(false);
        }

        if (runtime) runtime.modelElement = modelElement;
        window.repodModelLoaded = true;

        var rect = heroElement.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
        heroRatio = rect.height > 0 ? visibleHeight / rect.height : 0;
        heroSeen = true;

        resizeRuntime();
        window.requestAnimationFrame(function () {
          if (runtime && typeof runtime.drawScreen === 'function') runtime.drawScreen();
        });
        refreshReadiness();
        updateMount();
        return modelElement;
      }

      function runtimeReady() {
        return !!(
          window.repodHeroRuntime &&
          window.repodHeroRuntime.renderer &&
          window.repodHeroRuntime.renderer.domElement
        );
      }

      function refreshReadiness() {
        var hasModel = ensureModelWithoutRecursion();
        var isFallback = !!(hasModel && modelElement.classList.contains('model-load-failed'));
        var isReady = !!(
          hasModel &&
          (runtimeReady() || modelElement.classList.contains('model-is-ready') || isFallback)
        );

        sections.forEach(function (state) {
          state.element.classList.toggle('is-model-ready', isReady);
          if (!isReady) {
            setStatus(state, hasModel ? 'Preparing the shared 3D model…' : 'Waiting for the homepage Hero…');
          } else if (isFallback) {
            setStatus(state, '3D is unavailable — showing the product preview');
          } else {
            updateStatusFromScene(state);
          }
        });

        if (isReady) {
          resizeRuntime();
          syncSceneState();
        }
        return isReady;
      }

      function ensureModelWithoutRecursion() {
        if (modelElement && modelElement.isConnected) return true;

        var runtime = window.repodHeroRuntime;
        modelElement = runtime && runtime.modelElement
          ? runtime.modelElement
          : document.querySelector('.hero .hero__product');
        return !!modelElement;
      }

      function scheduleRetry() {
        if (retryTimer || retryRunning) return;
        var attempts = 0;

        function retry() {
          retryTimer = null;
          retryRunning = true;
          attempts += 1;
          ensureModel();
          var ready = refreshReadiness();
          updateMount();
          retryRunning = false;

          if (!ready && attempts < 150) {
            retryTimer = window.setTimeout(retry, 120);
          }
        }

        retryTimer = window.setTimeout(function () {
          if (!retryRunning) retry();
        }, 0);
      }

      function setStatus(state, text) {
        if (state.status) state.status.textContent = text;
      }

      function updateStatusFromScene(state) {
        var sceneState = getSceneState();
        var labels = {
          game: 'Game · ready to explore',
          music: 'Music · ready to explore',
          map: 'Map · ready to explore',
          pay: 'Pay · ready to explore',
          msg: 'Messages · ready to explore'
        };
        setStatus(state, labels[sceneState.app] || 'Your Repod is ready');
      }

      function chooseVisibleSection() {
        return sections
          .filter(function (state) { return state.ratio > 0; })
          .sort(function (a, b) { return b.ratio - a.ratio; })[0] || null;
      }

      function updateMount() {
        if (!ensureModel()) {
          scheduleRetry();
          return;
        }

        var target = chooseVisibleSection();

        if (heroRatio > 0.01) {
          restoreToHero();
        } else if (target) {
          mountInSection(target);
        }

        if (heroSeen || sections.some(function (state) { return state.seen; })) {
          var visible = activeSection ? activeSection.ratio > 0 : heroRatio > 0;
          window.repodInViewport = visible;
        }
      }

      function mountInSection(state) {
        if (!state || !state.mount || !state.mount.isConnected) return;
        if (window.repodExperienceScenesLoaded !== true) {
          setStatus(state, 'Preparing the interactive scenes…');
          if (!state.scenesLoading && typeof window.repodLoadExperienceScenes === 'function') {
            state.scenesLoading = true;
            window.repodLoadExperienceScenes(function () {
              state.scenesLoading = false;
              refreshReadiness();
              updateMount();
            });
          }
          return;
        }
        if (activeSection === state && modelElement.parentNode === state.mount) {
          lockModelToFront();
          setPresentationQuality(true);
          setPresentationLighting(true);
          applyDefaultScene(state);
          return;
        }

        sections.forEach(function (item) {
          item.element.classList.toggle('is-model-mounted', item === state);
        });

        lockModelToFront();
        state.mount.appendChild(modelElement);
        modelElement.classList.add('repod-experience__shared-product');
        activeSection = state;
        window.repodInViewport = true;
        setPresentationQuality(true);
        setPresentationLighting(true);
        applyDefaultScene(state);
        resizeRuntime();
        playEntranceAnimation();
        document.dispatchEvent(new CustomEvent('repod:mount-change', {
          detail: { location: 'experience', sectionId: state.id }
        }));
      }

      /* The shared model's entrance belongs to this stage. It is started here,
         on the frame the model lands on it, and runs to the end untouched —
         snapping it to the finished pose mid-flight is what made the arrival
         read as a stutter. Repeat arrivals are no-ops inside the intro. */
      function playEntranceAnimation() {
        var runtime = window.repodHeroRuntime;
        if (runtime && typeof runtime.playIntro === 'function') {
          runtime.playIntro();
          return;
        }
        if (window.productIntro && typeof window.productIntro.play === 'function') {
          window.productIntro.play();
        }
      }

      function lockModelToFront() {
        var controller = getModelController();
        if (!controller) return;
        var modelState = typeof controller.getState === 'function' ? controller.getState() : {};
        if (modelState.spinning && controller.toggleSpin) controller.toggleSpin();
        if (modelState.charging && controller.toggleCharge) controller.toggleCharge();
        if (modelState.latchOpen && controller.toggleLatch) controller.toggleLatch();
        if (controller.front) controller.front();
      }

      function setPresentationLighting(active) {
        var runtime = window.repodHeroRuntime;
        if (runtime && runtime.lighting && typeof runtime.lighting.set === 'function') {
          runtime.lighting.set(active);
        }
      }

      function setPresentationQuality(active) {
        var runtime = window.repodHeroRuntime;
        if (runtime && runtime.quality && typeof runtime.quality.set === 'function') {
          runtime.quality.set(active);
        } else {
          window.repodPresentationQuality = !!active;
        }
      }

      function restoreToHero() {
        if (!modelElement || !homeAnchor || !homeAnchor.parentNode) return;
        if (!activeSection && modelElement.parentNode === homeAnchor.parentNode) return;

        setPresentationQuality(false);
        setPresentationLighting(false);
        homeAnchor.parentNode.insertBefore(modelElement, homeAnchor.nextSibling);
        modelElement.classList.remove('repod-experience__shared-product');
        sections.forEach(function (state) {
          state.element.classList.remove('is-model-mounted');
        });
        activeSection = null;
        resizeRuntime();
        document.dispatchEvent(new CustomEvent('repod:mount-change', {
          detail: { location: 'hero' }
        }));
      }

      function resizeRuntime() {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            var runtime = window.repodHeroRuntime;
            if (runtime && typeof runtime.resize === 'function') {
              runtime.resize();
              return;
            }
            if (!window.renderer || !window.camera || !window.renderer.domElement) return;
            var container = window.renderer.domElement.parentElement;
            if (!container || !container.clientWidth || !container.clientHeight) return;
            window.camera.aspect = container.clientWidth / container.clientHeight;
            window.camera.updateProjectionMatrix();
            window.renderer.setSize(container.clientWidth, container.clientHeight);
          });
        });
      }

      function getSceneController() {
        return window.repodSceneController || (window.repodHeroRuntime && window.repodHeroRuntime.scenes);
      }

      function getSceneState() {
        var controller = getSceneController();
        if (controller && typeof controller.getState === 'function') return controller.getState();
        return { app: 'game', game: 'sunny', games: [], availableApps: ['game'] };
      }

      function applyDefaultScene(state) {
        if (state.defaultApplied || !runtimeReady()) return;
        state.defaultApplied = true;
        activateScene(state, state.defaultScene || 'game');
      }

      function activateScene(state, sceneId) {
        var controller = getSceneController();
        var button = state.element.querySelector('[data-repod-scene="' + sceneId + '"]');
        if (button) button.classList.add('is-loading');
        if (typeof window.audioInit === 'function') window.audioInit();

        if (!controller && window.repodExperienceScenesLoaded !== true && typeof window.repodLoadExperienceScenes === 'function') {
          window.repodLoadExperienceScenes(function () {
            activateScene(state, sceneId);
          });
          return;
        }

        if (controller && typeof controller.setApp === 'function') {
          controller.setApp(sceneId);
          window.setTimeout(syncSceneState, 40);
          window.setTimeout(syncSceneState, 500);
          window.setTimeout(syncSceneState, 1400);
          return;
        }

        var legacyButton = document.querySelector('#appbar button[data-app="' + sceneId + '"]');
        if (legacyButton) legacyButton.click();
        window.setTimeout(syncSceneState, 120);
      }

      function syncSceneState(event) {
        var sceneState = event && event.detail && event.detail.app ? event.detail : getSceneState();

        sections.forEach(function (state) {
          state.element.querySelectorAll('[data-repod-scene]').forEach(function (button) {
            var selected = button.getAttribute('data-repod-scene') === sceneState.app;
            button.setAttribute('aria-selected', selected ? 'true' : 'false');
            button.setAttribute('tabindex', selected ? '0' : '-1');
            if (selected || (sceneState.availableApps || []).indexOf(button.getAttribute('data-repod-scene')) !== -1) {
              button.classList.remove('is-loading');
            }
          });

          var sceneKeys = ['game', 'music', 'map', 'pay', 'msg'];
          var sceneNumber = state.element.querySelector('[data-repod-scene-number]');
          var sceneIndex = sceneKeys.indexOf(sceneState.app);
          if (sceneNumber && sceneIndex !== -1) {
            sceneNumber.textContent = '0' + (sceneIndex + 1) + ' / 05';
          }
          var sceneLabels = { game: 'Game', music: 'Music', map: 'Map', pay: 'Pay', msg: 'Messages' };
          if (state.stage && sceneLabels[sceneState.app]) {
            state.stage.setAttribute('aria-label', sceneLabels[sceneState.app] + ' interactive preview');
          }

          state.element.querySelectorAll('[data-repod-scene-bg]').forEach(function (bg) {
            bg.classList.toggle('is-active', bg.getAttribute('data-repod-scene-bg') === sceneState.app);
          });

          state.element.querySelectorAll('[data-repod-scene-desc]').forEach(function (desc) {
            desc.classList.toggle('is-active', desc.getAttribute('data-repod-scene-desc') === sceneState.app);
          });

          if (state.gameSwitcher) {
            state.gameSwitcher.hidden = sceneState.app !== 'game';
            renderGameButtons(state, sceneState);
          }
          if (state.element.classList.contains('is-model-ready')) updateStatusFromScene(state);
        });
      }

      function renderGameButtons(state, sceneState) {
        if (!state.gameButtons) return;
        var games = sceneState.games || [];
        var signature = games.map(function (game) { return game.id + ':' + game.title; }).join('|');

        if (state.gameButtons.getAttribute('data-signature') !== signature) {
          state.gameButtons.innerHTML = '';
          games.forEach(function (game) {
            var button = document.createElement('button');
            button.type = 'button';
            button.textContent = game.title;
            button.setAttribute('data-repod-game', game.id);
            button.addEventListener('click', function () {
              var controller = getSceneController();
              if (controller && typeof controller.selectGame === 'function') {
                controller.selectGame(game.id);
              }
              syncSceneState();
            });
            state.gameButtons.appendChild(button);
          });
          state.gameButtons.setAttribute('data-signature', signature);
        }

        state.gameButtons.querySelectorAll('[data-repod-game]').forEach(function (button) {
          button.setAttribute('aria-pressed', button.getAttribute('data-repod-game') === sceneState.game ? 'true' : 'false');
        });
      }

      function getModelController() {
        return window.repodModelController || (window.repodHeroRuntime && window.repodHeroRuntime.model);
      }

      function bindControls(state) {
        var buttons = Array.from(state.element.querySelectorAll('[data-repod-scene]'));
        buttons.forEach(function (button, index) {
          button.addEventListener('click', function () {
            activateScene(state, button.getAttribute('data-repod-scene'));
          });
          button.addEventListener('keydown', function (event) {
            var next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = buttons.length - 1;
            else return;
            event.preventDefault();
            buttons[next].focus();
            activateScene(state, buttons[next].getAttribute('data-repod-scene'));
          });
        });

      }

      /* A small desktop drift keeps the environment behind the fixed device. */
      function bindParallax(state) {
        if (!state.stage) return;
        if (!window.matchMedia('(pointer: fine)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        if (window.matchMedia('(max-width: 749px)').matches) return;
        var RANGE = 6;

        state.stage.addEventListener('pointermove', function (event) {
          var rect = state.stage.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var x = (event.clientX - rect.left) / rect.width - 0.5;
          var y = (event.clientY - rect.top) / rect.height - 0.5;
          state.element.style.setProperty('--repod-px', (-x * RANGE).toFixed(2) + 'px');
          state.element.style.setProperty('--repod-py', (-y * RANGE).toFixed(2) + 'px');
        });

        state.stage.addEventListener('pointerleave', function () {
          state.element.style.setProperty('--repod-px', '0px');
          state.element.style.setProperty('--repod-py', '0px');
        });
      }

      function register(element) {
        if (!element || element.getAttribute('data-repod-experience-initialized') === 'true') return;
        element.setAttribute('data-repod-experience-initialized', 'true');

        var state = {
          id: element.getAttribute('data-section-id') || '',
          element: element,
          mount: element.querySelector('[data-repod-model-mount]'),
          stage: element.querySelector('[data-repod-experience-stage]'),
          status: element.querySelector('[data-repod-status]'),
          gameSwitcher: element.querySelector('[data-repod-game-switcher]'),
          gameButtons: element.querySelector('[data-repod-game-buttons]'),
          defaultScene: element.getAttribute('data-default-scene') || 'game',
          defaultApplied: false,
          scenesLoading: false,
          ratio: 0,
          seen: false
        };

        sections.push(state);
        observer.observe(element);
        bindControls(state);
        bindParallax(state);
        syncSceneState();
        scheduleRetry();
      }

      function unregister(element) {
        var state = stateForElement(element);
        if (!state) return;
        observer.unobserve(element);
        if (activeSection === state) restoreToHero();
        sections = sections.filter(function (item) { return item !== state; });
      }

      document.addEventListener('repod:runtime-ready', function () {
        ensureModel();
        refreshReadiness();
        updateMount();
      });
      document.addEventListener('repod:scene-controller-ready', syncSceneState);
      document.addEventListener('repod:scene-change', syncSceneState);
      document.addEventListener('shopify:section:load', function (event) {
        var hero = document.getElementById('hero-' + event.detail.sectionId);
        if (hero) reconnectHero(hero);
        var section = document.getElementById('RepodExperience-' + event.detail.sectionId);
        if (section) register(section);
      });
      document.addEventListener('shopify:section:unload', function (event) {
        var section = document.getElementById('RepodExperience-' + event.detail.sectionId);
        if (section) unregister(section);
      });

      new MutationObserver(updateMount).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });

      return {
        register: register,
        unregister: unregister,
        restore: restoreToHero,
        reconnectHero: reconnectHero,
        refresh: function () {
          ensureModel();
          refreshReadiness();
          updateMount();
        }
      };
    })();

    window.repodExperienceManager = manager;
  }

  function init() {
    document.querySelectorAll('[data-repod-experience]').forEach(function (section) {
      manager.register(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
